<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <h1 class="title">Climbing Arrivals</h1>
      <app-cells>
        <app-select
          @input="onChangeCategory"
          v-model="category_filter"
          :options="category_options"
          :reduce="item => item.id"
          :filterable="false"
          :clearable="false"
          :searchable="false"
          placeholder="Category"
          class="select--200"
        />
      </app-cells>
      <div v-for="arrival_table_item of table.items" :key="arrival_table_item.name" style="margin-bottom: 40px;">
        <app-cells>
          <h2 class="title">{{ arrival_table_item.name }}</h2>
          <div v-if="arrival_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="arrival_table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__group><div class="table-default__left">Group</div></template>
          <template #group="{ row }">
            <router-link
              :to="{ name: 'climbing-arrivals-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.climbing_group.name }} ({{ dateFormat(row.date) }})
            </router-link>
          </template>
          <template #location="{ row }">{{ row.location.name }}</template>
          <template #managers="{ row }">
            <div class="table-default__controls">
              <div v-for="manager of row.managers" :key="manager.id" class="table-default__photo">
                <img
                  :src="getUserAvatar(manager.crop.crop_url)" alt="Avatar"
                  v-tooltip="{ content: manager.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
            </div>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getClimbingArrivalsDates } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'ClimbingArrivalsList',
  data() {
    return {
      is_loaded: false,
      table_preloader: false,
      category_filter: 'upcoming',
      category_options: [
        {
          id: 'upcoming',
          name: 'Upcoming',
        },
        {
          id: 'archive',
          name: 'Archive',
        },
      ],
      table_length: 0,
      table: {
        items: [],
        columns: ['group', 'location', 'pax', 'managers'],
        options: {
          headings: {
            group: 'Group',
            location: 'Location',
            pax: 'Pax',
            managers: 'Managers',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.getArrivalsList()
  },
  methods: {
    getArrivalsList() {
      this.table_preloader = true
      getClimbingArrivalsDates(
        {
          page: this.pagination.page,
          page_size: 40,
          group_by: 'date',
          range_type: 'day',
          category: this.category_filter
        }
      )
        .then(res => {
          this.table.items = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.is_loaded = true
          this.table_preloader = false
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.getArrivalsList()
    },
    onChangeCategory() {
      this.search = ''
      this.pagination.page = 1
      this.getArrivalsList()
    },
    dateFormat(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMM yyyy')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
